export default __webpack_public_path__ + "static/media/property_538.4fd30681.png";